import { useQuery } from "@tanstack/react-query";
import {
  fetchActiveVisitors,
  fetchAnalyticsSummary,
  type DateRange,
} from "@/lib/page-views";

export function useAnalyticsSummary(range: DateRange) {
  return useQuery({
    queryKey: ["analytics", "summary", range.from.toISOString(), range.to.toISOString()],
    queryFn: () => fetchAnalyticsSummary(range),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

export function useActiveVisitors() {
  return useQuery({
    queryKey: ["analytics", "active"],
    queryFn: () => fetchActiveVisitors(),
    staleTime: 10_000,
    refetchInterval: 15_000,
  });
}
